import React from 'react'
import { BaseLayout } from 'src/layouts'
import styles from './styles.module.scss'
import { Card } from './components/card'
import { WEBSITE } from 'src/consts'

export const Partner = () => {
  return (
    <BaseLayout
      seo={{
        title: 'COIN360 | Partner Companies in Digital Innovation',
        description:
          'COIN360s partner companies; driving innovation in asset management, media, blockchain projects, SEO, and decentralized trading.',
        canonical: `${WEBSITE}/partner`,
      }}
    >
      <div className={styles.container}>
        <div className={styles.header}>
          <h1 className={styles.headerText}>Our Partners</h1>
        </div>

        <div className={styles.itemContainer}>
          <Card
            href='https://hilbert.group/en/'
            src='/assets/hilbert-logo-lightgreen.svg'
            alt='Hilbert Group'
            width={200}
            height={150}
            name='Hilbert Group'
            description='Digital asset hedge fund with a focus on quantitative strategies.'
          />
          <Card
            href='https://cointelegraph.com/'
            src='/assets/cointelegraph.png'
            alt='Cointelegraph'
            width={200}
            height={150}
            name='Cointelegraph'
            description='Trusted source for news and analysis in the crypto industry.'
          />
          <Card
            href='https://www.4plusventures.com/'
            src='/assets/4plus-logo.svg'
            alt='4+ Ventures'
            width={200}
            height={150}
            name='4+ Ventures'
            description='Studio developing blockchain and crypto-related projects.'
          />
          <Card
            href='https://www.zingylabs.com/'
            src='/assets/zingy-labs-logo.svg'
            alt='Zingy Labs'
            width={200}
            height={150}
            name='Zingy Labs'
            description='Specialists in SEO-driven content and digital marketing.'
          />
          <Card
            href='https://jup.ag/'
            src='/assets/jupiter-logo.svg'
            alt='Jupiter'
            width={200}
            height={150}
            name='Jupiter'
            description='Decentralized exchange for fast, secure crypto trading.'
          />
          <Card
            href='https://www.gate.io/'
            src='/assets/logo-gate.svg'
            alt='Gate.io'
            width={200}
            height={150}
            name='Gate.io'
            description='Global exchange offering a wide range of crypto services.'
          />
          <Card
            href='https://www.mexc.com/'
            src='/assets/mexc-logo.svg'
            alt='Mexc'
            width={200}
            height={150}
            name='MEXC'
            description='Global cryptocurrency exchange offering diverse trading services.'
          />
          <Card
            href='https://www.maestrobots.com/'
            src='/assets/maestro-logo.webp'
            alt='Maestro'
            width={200}
            height={50}
            name='Maestro'
            description='Telegram bot for seamless on-chain crypto trading.'
          />
          <Card
            href='https://www.openloyalty.io/'
            src='/assets/logo-openloyalty.svg'
            alt='Maestro'
            width={200}
            height={150}
            name='Open Loyalty'
            description='A flexible, API-first loyalty platform designed for creating personalized loyalty programs with ease.'
          />
          <Card
            href='https://www.okx.com/join/59871220'
            src='/assets/logo-okx.svg'
            alt='OKX'
            width={200}
            height={150}
            name='OKX'
            description='An exchange offering trading tools and services'
          />
        </div>
      </div>
    </BaseLayout>
  )
}
